import api from "./api";

export function fnStoreEvidence(nActivityId, oData) {
     const response = api.post(`/operational-panel-activity-evidence/${nActivityId}`, oData, { headers: { 'Content-Type': 'multipart/form-data;' } });
     return response;
}
export function fnDeleteEvidence(nEvidenceId) {
     const response = api.delete(`/operational-panel-activity-evidence/${nEvidenceId}`,);
     return response;
}
export function fnEditTextEvidence(nEvidenceId, oData) {
     const response = api.patch(`/operational-panel-activity-evidence/${nEvidenceId}`, oData);
     return response;
}

export function fnGetDocumentsGED(cParams) {
     const response = api.get(`/operational-panel-activity-ged${cParams ? `?${cParams}` : ""}`);
     return response;
}

export function fnGetEvidences(nActivityId){
     const response = api.get(`/operational-panel/${nActivityId}/evidence`)
     return response
}